// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/public.scss
// module id = ./resources/assets/sass/public.scss
// module chunks = 0